import React from 'react';
import ReactDOM from 'react-dom';
import { EventQueue } from '@credit/utils';
import BrandLoading from './BrandLoading';

/**
 * 自研全屏 loading —— 替换 @credit/tips 的 loading。
 *
 * 语义与 @credit/tips 完全一致(逐行对齐其实现)：
 *   - loadingList: 并发计数(每次 show push 一个 id，hide pop 一个)
 *   - EventQueue: show/hide 排队 + 150ms 防抖，避免闪烁
 *   - showFullLoading   : list 为空则挂载 DOM，再 push
 *   - hideFullLoading   : pop；减到最后一个时卸载 DOM
 *   - setFullLoadingOnly: show 后 splice(1) 截断到只剩 1 个(保证唯一)
 *   - hideAllFullLoading: splice(1) 截断 + hide 卸载(全清)
 *   - lock/unlock/islock: 锁，锁定时 show 无效
 *
 * 唯一区别：渲染从 @credit/tips 的 rmc-notification 三点 DOM 换成自研品牌组件(BrandLoading)，
 * DOM 完全自主，未来扩展(文案/进度/多态)只改 BrandLoading 即可。
 * common.tsx / v2/common.tsx 的 4 个导出无缝指向这里，85 处调用点无需改动。
 */
class FullLoading {
  private loadingList: string[] = [];

  private container: HTMLDivElement | null = null;

  private queue = new EventQueue();

  private locked = false;

  private mount = () => {
    if (this.container) return;
    this.container = document.createElement('div');
    document.body.appendChild(this.container);
    ReactDOM.render(React.createElement(BrandLoading), this.container);
  };

  private unmount = () => {
    if (!this.container) return;
    ReactDOM.unmountComponentAtNode(this.container);
    this.container.parentNode?.removeChild(this.container);
    this.container = null;
  };

  showFullLoading = () => {
    if (this.locked) return;
    this.queue
      .add(() => {
        if (this.loadingList.length <= 0) this.mount();
        this.loadingList.push(new Date().toISOString());
      }, 150)
      .trigger();
  };

  hideFullLoading = () => {
    this.queue
      .add(() => {
        if (this.loadingList.length === 1) {
          this.loadingList.pop();
          this.unmount();
        } else {
          this.loadingList.pop();
        }
      }, 150)
      .trigger();
  };

  setFullLoadingOnly = () => {
    this.showFullLoading();
    this.queue.add(() => this.loadingList.splice(1), 0).trigger();
  };

  hideAllFullLoading = () => {
    this.queue.add(() => this.loadingList.splice(1), 0).trigger();
    this.hideFullLoading();
  };

  lock = () => {
    this.locked = true;
  };

  unlock = () => {
    this.locked = false;
  };

  islock = () => this.locked;
}

export default new FullLoading();
